import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import config from "../../utils/config";
import { ImageValidation } from "../Validation/ImageValidation";
import Rejectreason from "./Rejectreason";
import { useKycNationVerifyMutation } from "../../redux/kycApi";

const { imageUrl } = config;

function NationId({ kycTrack, refetch }) {
  const [nationId, setNationId] = useState("");
  const [nationImage, setNationImage] = useState(null);
  const [previewImage, setPreviewImage] = useState("/assets/img/icon2.png");
  const [nationIdError, setNationIdError] = useState("");
  const [nationImageError, setNationImageError] = useState("");
  const [rejectionReason, setRejectionReason] = useState("");
  const [btnDisable, setBtnDisable] = useState(false);

  const [kycNationVerify] = useKycNationVerifyMutation();

  const status = kycTrack?.progress?.nation_verification?.status;
  const isEditable = status === "pending" || status === "rejected";
  const nationData = kycTrack?.progress?.nation_verification?.data;

  useEffect(() => {
    const loadImageAsFile = async (url, filename = "nation_id.jpg") => {
      try {
        const res = await fetch(url);
        const blob = await res.blob();
        return new File([blob], filename, { type: blob.type });
      } catch (err) {
        console.error("Failed to convert image URL to File:", err);
        return null;
      }
    };

    if (nationData) {
      setNationId(nationData.nation_id || "");
      setRejectionReason(nationData.reason || "");

      if (nationData.image) {
        const url = imageUrl + nationData.image;
        setPreviewImage(url);
        loadImageAsFile(url, "nation_id.jpg").then((file) => {
          if (file) setNationImage(file);
        });
      }
    }
  }, [nationData]);

  const handleIdChange = (e) => {
    const value = e.target.value.toUpperCase().replace(/[^A-Z0-9-]/g, "");
    setNationId(value);

    if (!value) {
      setNationIdError("This field is required");
    } else if (value.length < 6 || value.length > 20) {
      setNationIdError("Nation ID must be 6 to 20 characters");
    } else {
      setNationIdError("");
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setNationImage(file);

    const error = ImageValidation("Nation ID", file);
    setNationImageError(error);
    setPreviewImage(file ? URL.createObjectURL(file) : "/assets/img/icon2.png");
  };

  const handleSubmit = async () => {
    if (!nationId || !nationImage) {
      setNationIdError(!nationId ? "This field is required" : "");
      setNationImageError(!nationImage ? "This field is required" : "");
      return;
    }

    if (nationIdError || nationImageError) return;

    setBtnDisable(true);
    setTimeout(() => setBtnDisable(false), 3000);

    const formData = new FormData();
    formData.append("nation_id", nationId);
    formData.append("nation_image", nationImage);

    const { data, error: apiError } = await kycNationVerify(formData);

    if (apiError) {
      toast.error(apiError?.data?.message || "Submission failed");
      return;
    }
    if (data) {
      toast.success(data.message || "Submitted successfully");
      refetch();
    } else {
      toast.error(data?.message || "Unexpected error");
    }
  };

  return (
    <div className="passport-outer">
      <div className="">
        {/* <div className="col-md-3 col-12"></div> */}
        <div className="">
          <div className="white_box">
            <h6 className="position-relative">Nation ID Verification</h6>
            <b className="mt-0">Requirements</b>
            <ul className="dit_ul mb-4">
              <li>The photo/scan must be clear, in color and uncompressed.</li>
              <li>The photo/scan must be not edited and not cropped.</li>
              {/* <li>
                The document must be valid at least 3 months after the
                verification submission date.
              </li> */}
              <li>
                The full name and date of birth you provided in the "Personal
                information" section
              </li>
              <li>should exactly match the ones in your document.</li>
              <li>Min size 10 Kb / Max size 2 Mb.</li>
            </ul>

            <div className="row">
              <div className="form-group col-lg-6 col-md-6">
                <label>Nation ID Number</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Nation ID Number"
                  name="nationId"
                  value={nationId}
                  onChange={handleIdChange}
                  disabled={!isEditable}
                />
                {nationIdError && (
                  <div className="text-danger">{nationIdError}</div>
                )}
              </div>
            </div>

            <div className="row">
              <div className="form-group col-lg-4 col-md-6">
                <div id="file-upload-form" className="uploader mt-3">
                  <input
                    type="file"
                    id="nationImage"
                    accept="image/*"
                    name="nationImage"
                    onChange={handleImageChange}
                    disabled={!isEditable}
                  />
                  <label htmlFor="nationImage" id="file-drag">
                    <img
                      src={previewImage}
                      className="img-fluid22"
                      alt="Nation ID"
                    />
                    <div id="start">
                      <span className="fasi"></span>
                      <div>Upload Nation ID Image</div>
                      <div id="notimage" className="hidden">
                        Please select an image
                      </div>
                    </div>
                    <div id="response" className="hidden">
                      <div id="messages"></div>
                      <progress
                        className="progress"
                        id="file-progress"
                        value="0"
                      >
                        <span>0</span>%
                      </progress>
                    </div>
                  </label>
                </div>
                {nationImageError && (
                  <div className="text-danger">{nationImageError}</div>
                )}
              </div>
            </div>

            <p className="mt-0">
              *only jpeg, jpg & png files supported <br />
              *For changing image, click on image upload section again.
            </p>

            <Rejectreason reason={rejectionReason} status={status} />

            {isEditable && (
              <button
                className="btn btn_man w100px"
                onClick={handleSubmit}
                disabled={btnDisable}
              >
                {status === "pending" ? "Submit" : "Re-submit"}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default NationId;
